import PropTypes from 'prop-types';
import React from 'react';
import { PositionedOverlay } from 'reaxl';
import KBBDealIndicator from '../KBBDealIndicator/index.js';

/**
 *  molecule to encapsulate standard PositionOverlay + KBBDealIndicator logic
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function KBBDealIndicatorOverlay(_ref) {
  let {
    className,
    position = 'topRight',
    children,
    offsetTop = 50,
    pricingDetail,
    ...rest
  } = _ref;
  const props = {
    pricingDetail,
    position
  };
  return /*#__PURE__*/_jsxs(PositionedOverlay, {
    className: className,
    shrinkwrap: false,
    ...rest,
    children: [/*#__PURE__*/_jsx(PositionedOverlay.Base, {
      children: children
    }), /*#__PURE__*/_jsx(PositionedOverlay.Anchor, {
      position: position,
      offsetTop: offsetTop,
      children: /*#__PURE__*/_jsx(KBBDealIndicator, {
        ...props
      })
    })]
  });
}
export default KBBDealIndicatorOverlay;